import messageResource from '../../../../messageResource'
import ChartPDFParametersFormatter from './ChartPDFParametersFormatter'

export default class ChartPDFParametersFormattingStrategy {
    init(selectorsData, dateFormat, dateFormatForFile, reportAuthorizationInfo, reportParamsStringBuilderConstructor) {
        const ugrEnabled = selectorsData.enabledFeatures ?
                           selectorsData.enabledFeatures.hasOwnProperty(ReportChartConstants.UGRFeature) :
                           null
        const tzgEnabled = selectorsData.enabledFeatures ?
                           selectorsData.enabledFeatures.hasOwnProperty(ReportChartConstants.TZGFeature) :
                           null
        this.parametersFormatter = new ChartPDFParametersFormatter().init({
            selectorsData,
            dateFormat,
            ugrEnabled,
            tzgEnabled,
            reportAuthorizationInfo,
            reportParamsStringBuilderConstructor,
        })

        this.dateParametersFormattingStrategy = this.createDateParametersFormattingStrategy(dateFormat, dateFormatForFile)

        return this
    }

    createDateParametersFormattingStrategy(dateFormat, dateFormatForFile) {
        // abstract
    }

    formatChartPDFFilterInformation(selectedParameters) {
        // abstract
    }

    formatChartPDFHeaderTitle(selectedParameters) {
        return messageResource.getMessage(
            'report.chart_pdf.header_label',
            [
                this.parametersFormatter.formatChartTypeValue(selectedParameters.chartTypeValue),
                this.parametersFormatter.formatGroupingLevelValue(selectedParameters.groupingLevelValue)
            ]
        )
    }

    getTableHeaders(selectedParameters) {
        return {
            category: this.parametersFormatter.getChartCategoryName(selectedParameters.groupingLevelValue),
            total: messageResource.getMessage('report.chart_pdf.table_header.total'),
            user: messageResource.getMessage('report.chart_pdf.table_header.me'),
            team: messageResource.getMessage('report.chart_pdf.table_header.my_team'),
            notAssigned: messageResource.getMessage('report.chart_pdf.table_header.not_assigned_users')
        }
    }

    formatChartPDFHeaderDateInformation(selectedParameters) {
        return this.dateParametersFormattingStrategy.formatDateInformation(selectedParameters.dateParameters)
    }

    formatGrandTotalDescription(selectedParameters) {
        return {
            label: messageResource.getMessage('report.chart_pdf.grand_total_label',
                [this.parametersFormatter.formatGrandTotalValueType(selectedParameters.chartTypeValue)]),
            postfix: this.parametersFormatter.formatGrandTotalPostfix(selectedParameters.chartTypeValue)
        }
    }

    formatChartPDFFileName(selectedParameters) {
        const fileNameParts = []
        fileNameParts.push(this._capitalizeFirstLetterInWords(this.parametersFormatter.formatChartTypeValue(selectedParameters.chartTypeValue)))//show..
        fileNameParts.push(this._capitalizeFirstLetterInWords(this.parametersFormatter.formatGroupingLevelValue(selectedParameters.groupingLevelValue)))//by..
        fileNameParts.push(this.dateParametersFormattingStrategy.formatDateForFileName(selectedParameters.dateParameters))//date range
        return messageResource.getMessage('report.chart_pdf.file_name', fileNameParts)
    }

    _capitalizeFirstLetterInWords(string) {
        var replacer = function(str, p1, p2, offset, s) {
            return p1 ? p1.toUpperCase() : p2.toUpperCase()
        }
        return string.replace(/(\s\w)|(^\w)/g, replacer)
    }
}



// WEBPACK FOOTER //
// ./web/js/reports/charts/pdfgenerator/formatters/ChartPDFParametersFormattingStrategy.js